<template>
  <div class="content">
    <span class="progress_row">
      <span class="label">{{ description }}<span>{{ progress }} %</span></span>
      <span class="progressbar"><span class="progress" :style="{ width: progress + '%' }"></span></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'sidebar-progressbar',
  props: {
    progress: {
      type: Number,
      default: 0
    }
  },
  computed: {
    description() {
      return this.$gettext('Zpracováno')
    }
  }
}
</script>
